export const NameContent = {
  content1: 'First name',
  content2: 'MI',
  content3: 'Last name',
  content4: 'Your entry is invalid.',
};
